<template>
  <AnalyticsWidget
    title="Top Contacts - Operational DIFOT"
    subTitle="Based on orders completed during the date range"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <div class="p-2 h-100">
      <ReportFilterPopover
        headerTitle="Contact List Filter"
        :showApplyButton="true"
        :showResetButton="true"
        :appendToBody="true"
        alignment="left"
        placement="bottom-end"
        @apply="applyContactListFilter"
        @reset="resetContactListFilter">
        <template v-slot:popover>
          <ReportFilterGroup label="Date Filter">
            <ReportDateRangeSelect
              :startDate="editingContactListFilter.startDate"
              :endDate="editingContactListFilter.endDate"
              @updateStartDate="editingContactListFilter.startDate = $event"
              @updateEndDate="editingContactListFilter.endDate = $event"
            />
          </ReportFilterGroup>
        </template>
        <template v-slot:filterDisplay>
          <div>
            <i class="far fa-calendar mr-2"></i>{{appliedContactListFilter.startDate | formatDate}} - {{appliedContactListFilter.endDate | formatDate}}
          </div>
        </template>
      </ReportFilterPopover>

      <LoadingPanel :loading="loading" />
      <AnalyticsBreakdownTable v-if="!loading">
        <template v-slot:header>
          <tr>
            <th>Contact</th>
            <th><Tooltip label="Only includes orders with a reporting code set" helpStyle>Orders</Tooltip></th>
            <th>On Time</th>
            <th><Tooltip label="Operational DIFOT of orders that were completed on time" helpStyle>DIFOT</Tooltip></th>
            <th>Primary Cause</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="contactInfo of topContactList" :key="contactInfo.contactId">
            <td><LinkContact :id="contactInfo.contactId" :name="contactInfo.contactName" /></td>
            <td>{{ contactInfo.hitCount + contactInfo.missCount + contactInfo.excludeCount }}</td>
            <td>{{ contactInfo.hitCount }}</td>
            <td>{{formatPercent(getContactOperationalDIFOT(contactInfo))}}</td>
            <td>{{formatLookupName(contactInfo.topMissCode, ItemOperationalReportingCodeLookup) || 'N/A' }}</td>
          </tr>
        </template>
      </AnalyticsBreakdownTable>
    </div>

  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

import { ItemOperationalReportingCodeLookup } from '@/store/types'

export default {
  name: 'OrderDIFOTContactListWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell,
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  props: {
    contactId: Number,
    taskType: Object,
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    hasContactFilter() {
      return this.contactId != null
    },
    taskTypeList() {
      return this.orderDIFOTSummaryData.taskTypeList || []
    },
    topContactList() {
      return (this.orderDIFOTSummaryData.contactList || [])
    }
  },
  data() {
    return {
      loading: true,
      orderDIFOTSummaryData: {},

      defaultContactListFilter: {
        startDate: moment().local().subtract(30, 'days').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString(),
      },
      editingContactListFilter: {},
      appliedContactListFilter: {},
    }
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  created() {
    this.ItemOperationalReportingCodeLookup = ItemOperationalReportingCodeLookup
  },
  mounted() {
    this.editingContactListFilter = _.clone(this.defaultContactListFilter)
    this.appliedContactListFilter = _.clone(this.defaultContactListFilter)

    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      var params = {
        startDate: this.appliedContactListFilter.startDate,
        endDate: this.appliedContactListFilter.endDate,
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
        maxContactCount: 12
      }

      this.$apiService.analyticsService.getOrderDIFOTSummary(params)
      .then(response => {
        this.orderDIFOTSummaryData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
        console.error(err)
      })
    },
    reloadData() {
      this.requestData()
    },
    applyContactListFilter() {
      this.appliedContactListFilter = _.clone(this.editingContactListFilter)

      this.reloadData()
    },
    resetContactListFilter() {
      this.editingContactListFilter = _.clone(this.defaultContactListFilter)
      this.appliedContactListFilter = _.clone(this.defaultContactListFilter)

      this.reloadData()
    },
    getContactOperationalDIFOT(contactInfo) {
      var validOrderCount = contactInfo.hitCount + contactInfo.missCount
      if(validOrderCount > 0)
        return (contactInfo.hitCount / validOrderCount) * 100

      return 0
    }
  }
}
</script>